import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const app = initializeApp({
  apiKey: 'AIzaSyCQBBrys3A2sZHRzl3vZK5BQwo6kiLN4no',
  authDomain: 'selfstoragekorea-5aaf6.firebaseapp.com',
  projectId: 'selfstoragekorea-5aaf6',
  storageBucket: 'selfstoragekorea-5aaf6.appspot.com',
  messagingSenderId: '842518515616',
  appId: '1:842518515616:web:60f5ee2a3150c7c1891ec5',
  measurementId: 'G-K1EEZ6VW4C',
});

const firestore = getFirestore(app);

export { firestore };
